module.exports = __webpack_public_path__ + "img/logo.ec6249fc.png";